export const QueryParamsConst = {
  ORDER: 'order',
  PER_PAGE: 'take',
  QUERY: 'q',
  FILTERS: 'filters',
  PAGE: 'page',
  // news filter
  YEAR: 'year',
  LINE: 'line',
  TYPE: 'type',
  INDUSTRY: 'industry',
  // build and price filters
  SERIES: 'series',
  MODEL: 'model',
  // Download Brochure Filters
  CATEGORIES: 'categories',
  SEARCH_BROCHURE: 'searchbrochure',
  SEARCH_BROCHURE_ID: 'searchid',

  // Splash Page
  USER_MARKET_SELCTION: 'usermarketselection',
};
